var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { ON_RAMP_PROVIDERS } from '../../constants/constants.js';
import styled from 'styled-components';
import { CpslButton, CpslIcon, CpslSpinner, CpslText } from '@usecapsule/react-components';
import { motion } from 'framer-motion';
export const OnRampProviderButton = ({ config, index, onClick: _onClick }) => {
    const [isLoading, setIsLoading] = useState(false);
    const provider = config.providers[index];
    const { feeLower, feeUpper, name, icon, backgroundColors } = ON_RAMP_PROVIDERS[provider];
    const feeString = `Fee ${feeLower}% - ${feeUpper}%`;
    const onClick = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        yield _onClick();
        setIsLoading(false);
    });
    return (_jsx(StyledButton, { "$gradientColors": backgroundColors, fullWidth: true, onClick: onClick, children: _jsxs(Container, { "$backgroundColor": backgroundColors[1], children: [_jsx(IconContainer, { children: _jsx(CpslIcon, { icon: icon }) }), _jsxs(ProviderInfoContainer, { children: [_jsx(Text, { variant: "bodyL", weight: "medium", children: name }), _jsx(ProviderInfoInnerContainer, { children: _jsx(Text, { variant: "bodyXS", weight: "medium", children: feeString }) })] }), isLoading ? _jsx(CpslSpinner, { size: 16 }) : _jsx(Chevron, { icon: "chevronUp" })] }) }));
};
const StyledButton = styled(CpslButton) `
  width: 100%;
  --button-primary-background-color: ${({ $gradientColors }) => `linear-gradient(90deg, ${$gradientColors[0]} 0%, ${$gradientColors[1]} 100%)`};
  --button-primary-hover-background-color: ${({ $gradientColors }) => `linear-gradient(90deg, ${$gradientColors[0]} 0%, ${$gradientColors[0]} 100%)`};
  --button-primary-active-background-color: ${({ $gradientColors }) => `linear-gradient(90deg, ${$gradientColors[0]} 0%, ${$gradientColors[0]} 100%)`};
`;
const Container = styled(motion.div) `
  display: flex;
  gap: 8px;
  flex: 1;
  align-items: center;

  & cpsl-spinner {
    --background-color: ${({ $backgroundColor }) => `${$backgroundColor}`};
  }
`;
const ProviderInfoContainer = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 2px;
`;
const ProviderInfoInnerContainer = styled.div `
  display: flex;
  gap: 16px;
`;
const IconContainer = styled.span `
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 100%;
  height: 48px;
  width: 48px;
`;
const Text = styled(CpslText) `
  &::part(text-element) {
    color: #fff;
  }
`;
const Chevron = styled(CpslIcon) `
  transform: rotate(90deg);
  --icon-color: #fff;
`;
